export const emailCalendarImages = {
  calendar_detail: 'assets/img/graphics/calendar-detail.svg',
  calendar_2_icon: 'assets/menu-customisation-icons/Calendar/calendar2.svg',
  calendar_9_images: 'assets/menu-customisation-icons/Calendar/calendar9.svg',
};
